/**
 * @name: task
 * @description: 工单(待办事项)
 * @author: qq2575896094
 * @time: 2024/7/18
 */

const prefix = '/onlinecs/task'

// 查询任务列表
export const queryTaskList = `${prefix}/queryTaskList`

// 查询任务详情
export const queryTaskDetail = `${prefix}/queryTaskDetail`

// 添加备注,评论
export const addTaskRemark = `${prefix}/addTaskRemark`

// 完成任务
export const completeTask = `${prefix}/completeTask`

// 转交
export const updateTaskAssignee = `${prefix}/updateTaskAssignee`

// 创建任务
export const createTask = `${prefix}/createTask`

// 获取所有任务类型
export const getAllTaskTypeConfig = `${prefix}/getAllTaskTypeConfig`

// 流量点位点击数据
export const queryTrackingPointList = `${prefix}/queryTrackingPointList`

// 流量点位点击数据下载
export const downloadTrackingPointListUrl = `${prefix}/downloadTrackingPointList`
